module.exports = __webpack_public_path__ + "assets/img/33320754d8efa439da9e8bce0bf7539b.svg";